import React from 'react';
import { Quote, Linkedin } from 'lucide-react';

const NewReferencesSection = () => {
  const references = [
    {
      id: 1,
      text: 'Peter je vždy na príjme pripravený pomôcť a vysvetliť najlepšie možnosti v danej situácii. Vybaviť hypotéku a investicie vieš všade. Ak ale chceš budovať a zvelaďovať svoj majetok, Peťo je voľba číslo 1.',
      author: 'Peter',
      role: 'Senior programátor',
      avatar: '/ref_2.png',
      color: 'bg-brand-dark-blue'
    },
    {
      id: 2,
      text: 'Konzultácie s Peťom sú vždy veľmi hodnotné. Prvýkrát mám stratégiu, ktorej rozumiem a ktorá je udržateľná.',
      author: 'Erich Stark',
      role: 'Zakladatel Lucanto.eu',
      avatar: '/ref_3.png',
      color: 'bg-brand-orange'
    },
    {
      id: 3,
      text: 'Peter je mimoriadne systematický a pragmatický líder, ktorý dokáže vidieť za roh. Jeho schopnosť vnímať a efektívne využívať trhové príležitosti je výnimočná.',
      author: 'Jergy Holéczy',
      role: 'Autor, mentor',
      avatar: '/ref_1.jpg',
      color: 'bg-green-600'
    },
    {
      id: 4,
      text: 'Konzultácia s Peťom bola veľmi hodnotná, úderná, rýchla a rovno k veci bez zbytočných omáčok. Vyhodnotili sme môj aktuálny stav, ponúkol mi nový uhol pohľadu a hlavne prezradil svoje cenné know-how a pomohol sa mi zorientovať v nastavení plánu cez presné čísla a fakty.',
      author: 'Romana Bodnárová',
      role: 'Klientka',
      avatar: '/ref_4.jpg',
      color: 'bg-brand-baby-blue',
      linkedin: 'https://sk.linkedin.com/in/romana-bodn%C3%A1rov%C3%A1'
    }
  ];

  return (
    <section id="referencie" className="section bg-white overflow-x-clip">
      <div className="container mx-auto px-4 sm:px-5 max-w-full min-w-0">
        <div className="text-center mb-12 sm:mb-16 px-1">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold mb-6 text-brand-dark-blue leading-tight break-words">
            Výsledky hovoria za všetko
          </h2>
        </div>

        {/* Unified Card Style matching Book Landing */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 max-w-5xl mx-auto min-w-0">
          {references.map((ref) => (
            <div key={ref.id} className="bg-gray-50 p-6 sm:p-10 rounded-3xl relative hover:shadow-xl transition-shadow border border-gray-100 flex flex-col min-w-0">
              <div className="absolute top-8 right-8 text-4xl text-brand-dark-blue/10 serif font-bold">"</div>

              <p className="text-lg text-gray-700 italic mb-8 relative z-10 leading-relaxed flex-grow">
                {ref.text}
              </p>

              <div className="flex items-center gap-4 pt-6 border-t border-gray-200">
                <div className={`w-12 h-12 ${ref.color} text-white rounded-full flex items-center justify-center font-bold text-xl overflow-hidden`}>
                  {/* If avatar exists try to show it, else show initial */}
                  {ref.avatar ? (
                    <img src={ref.avatar} alt={ref.author} className="w-full h-full object-cover" />
                  ) : (
                    ref.author.charAt(0)
                  )}
                </div>
                <div>
                  <p className="font-bold text-brand-dark-blue text-lg">{ref.author}</p>
                  <p className="text-sm text-gray-500">{ref.role}</p>
                </div>
                {ref.linkedin && (
                  <a
                    href={ref.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`LinkedIn – ${ref.author}`}
                    className="ml-auto text-gray-400 hover:text-brand-orange transition-colors"
                  >
                    <Linkedin size={20} />
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewReferencesSection;